
export default {
    props: {
        label: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: true
        },
        value: {
            type: String,
            default: ''
        },
        maxlength: {
            type: Number,
            default: 999
        }
    },
    data () {
        return {
        }
    },
    computed: {
        inputAttrs () {
            const attrs = { ...this.$attrs }
            // 如果是number类型，移除maxlength属性，因为不支持
            if (attrs.type === 'number') {
                delete attrs.maxlength
            } else {
                attrs.maxlength = this.maxlength
            }
            return attrs
        }
    },
    created () { },
    methods: {
        handleInput (event) {
            let value = event.target.value

            // 如果是number类型且设置了maxlength，手动限制长度
            if (this.$attrs.type === 'number' && this.maxlength) {
                if (value.length > this.maxlength) {
                    value = value.slice(0, this.maxlength)
                    event.target.value = value
                }
            }

            this.$emit('input', value)
        }
    }
}
